module.exports = __webpack_public_path__ + "static/media/galdinsPlayed_500000_1000000.24a6b48c.png";